import { render, staticRenderFns } from "./CRSScore.vue?vue&type=template&id=20ada5ee"
import script from "./CRSScore.vue?vue&type=script&lang=js"
export * from "./CRSScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports